import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import './Homepage.css';
import TabContent from './HomepageDemo';
import { Analytics } from "@vercel/analytics/react"; // Add this line


function Homepage() {
  const navigate = useNavigate();
  const [activeTab, setActiveTab] = useState('Scribe');
  const [triggerPulse, setTriggerPulse] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768); // Example breakpoint


  useEffect(() => {
    if (activeTab === 'Learn') {
      document.body.style.background = 'black';
    } else if (activeTab === 'Q+A') {
      document.body.style.background = 'grey';
    } else {
      document.body.style.background = 'rgba(40, 154, 166, 0.7)';
    }
    return () => {
      document.body.style.background = '';
    };
  }, [activeTab]);

  useEffect(() => {
    const handleResize = () => setIsMobile(window.innerWidth < 768);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const navigateToLogin = () => {
    navigate('/login');
  };

  const heroHeadline = () => {
    switch (activeTab) {
      case 'Scribe':
        return 'Medical Assistant';
      case 'Q+A':
        return 'Research Assistant';
      default:
        return 'Learning Companion';
    }
  };

  
  
  const typewriterClass = () => {

    if (isMobile) return '';

    switch (activeTab) {
      case 'Learn':
        return 'typewriter-text typewriter-learn';
      case 'Scribe':
        return 'typewriter-text typewriter-scribe';
      case 'Q+A':
        return 'typewriter-text typewriter-qa';
      default:
        return 'typewriter-text';
    }
  };

  const buttonStyle = {
    fontFamily: 'arial',
    fontSize: '20px',
    display: 'block', // Make buttons stack vertically
    width: '100%', // Full width of the container
    padding: '15px', // Add some padding
    border: 'none', // Remove border
    backgroundColor: 'white', // Slightly off-white background for elevation effect
    textAlign: 'left', // Align text to the left
    color: 'rgba(40, 154, 166, 1.0)', // Button text color
    cursor: 'pointer', // Change cursor on hover
    marginTop: '20px',
    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.4)', // Add shadow to create elevated effect
    transition: 'transform 0.3s ease', // Smooth transition for click effect
    ':hover': {
      transform: 'translateY(-2px)', // Slightly raise button on hover
    },
    ':active': {
      transform: 'translateY(2px)', // Press down button on click
    },
    borderRadius: '20px',
    opacity: 0.9,
    marginLeft: '30px',
  };
  
  return (
    <div>
      <div className="homepage-container">
        <div className="typewriter">
          <h1 style={{ marginTop: '20px' }}>
            <strong>medr</strong> <span style={{ fontWeight: 'lighter', fontFamily: 'Arial' }}>| {activeTab}</span>
            <div className="hamburger-menu" onClick={() => setIsMenuOpen(!isMenuOpen)} style={{ position: 'absolute', top: 0, right: 0, padding: '20px' }}>
  &#9776;
</div>
{isMenuOpen && (
  <div className={`menu-dropdown ${isMenuOpen ? 'show' : ''}`} style={{paddingTop: '35px', paddingLeft: '10px', borderRadius: '20px 0 0 0',width: '100%', position: 'fixed', top: 0, right: isMenuOpen ? '0' : '-70%', height: '100%', backgroundColor: 'rgba(40, 154, 166, 0.8)', transition: 'right 0.3s', zIndex: '2000'}}>
<button onClick={() => setIsMenuOpen(false)} className="close-btn" aria-label="Close menu" style={{color: 'white', fontSize: '40px'}}>×</button>    
<button onClick={() => navigate('/pricing')} style={{...buttonStyle, backgroundColor: 'white'}}>Pricing</button>
<button onClick={() => navigate('/start')} style={{...buttonStyle, backgroundColor: 'white'}}>How It Works</button>
    <button onClick={() => navigate('/security')} style={buttonStyle}>Security</button>
    <button onClick={navigateToLogin} style={buttonStyle}>Login</button>
  </div>
)}
          </h1>
          
          <div className="navbar">
            <button onClick={() => setActiveTab('Learn')} 
              style={{ fontWeight: activeTab === 'Learn' ? 'bold' : 'normal' }}
            >
              Learn
            </button>
            <button 
              onClick={() => setActiveTab('Scribe')} 
              style={{ fontWeight: activeTab === 'Scribe' ? 'bold' : 'normal' }}
            >
              Scribe
            </button>
            <button 
              onClick={() => setActiveTab('Q+A')} 
              style={{ fontWeight: activeTab === 'Q+A' ? 'bold' : 'normal' }}
            >
              Q+A
            </button>
          </div>
        </div>
        <button 
  onClick={() => navigate('/pricing')}
  style={{
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '20px',
    marginRight: '350px',
    border: '2px solid white',
    color: 'white',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    paddingRight: 15,
    paddingLeft: 15,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: 13
  }}
>
  Pricing
</button>
        <button 
  onClick={() => navigate('/start')}
  style={{
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '20px',
    marginRight: '220px',
    border: '2px solid white',
    color: 'white',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    paddingRight: 15,
    paddingLeft: 15,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: 13,
    animation: triggerPulse ? 'pulse 2s infinite' : 'none'
  }}
>
  How It Works
</button>
<button 
  onClick={() => navigate('/security')}
  style={{
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '20px',
    marginRight: '120px',
    border: '2px solid white',
    color: 'white',
    backgroundColor: 'transparent',
    cursor: 'pointer',
    paddingRight: 15,
    paddingLeft: 15,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: 13
  }}
>
  Security
</button>
<button 
  onClick={navigateToLogin}
  style={{
    position: 'absolute',
    top: 0,
    right: 0,
    marginTop: '20px',
    marginRight: '40px', // This remains for the Login button
    border: '2px solid white',
    color: 'rgba(40, 154, 166, 1.0)',
    backgroundColor: 'white',
    cursor: 'pointer',
    paddingRight: 15,
    paddingLeft: 15,
    paddingTop: 10,
    paddingBottom: 10,
    borderRadius: '10px',
    fontWeight: 'bold',
    fontSize: 13,
    

  }}
>
  Login
</button>

<div className="hero-section">
<img src="/assets/medr_qr.png" alt="medr QR Code" className="desktop-only-image" style={{ width: '128px', height: '128px' }} />
<div style={{ opacity: 0 }}> br</div>
  <div className="hero-headline">
    The <span className="highlighted-word">Ultimate</span><br/><span className={typewriterClass()}>{heroHeadline()}</span>
  </div>
  <div className="hero-subheading">
    <span style={{ fontFamily: 'Orbitron', fontWeight: 'bold', letterSpacing: 4 }}>medr</span> reduces your clinical admin, whilst providing the most tailored medical learning experience.
  </div>
  <button 
  onClick={() => {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;
    // Check for iOS devices
    if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
      window.location.href = 'https://apps.apple.com/us/app/medr/id1585927466?uo=4'; // Replace 'YOUR_APP_ID' with your actual App Store ID
    } 
    // Check for Android devices
    else if (/android/i.test(userAgent)) {
      window.location.href = 'https://play.google.com/store/apps/details?id=com.kaveshan.medr&hl=en_AU&gl=US&pli=1'; // Replace 'YOUR_PACKAGE_NAME' with your actual package name
    }
  }}
  className="get-started-mobile"
>
  Download
</button>
  <div className="mobile-text-container">
  This is additional information visible on mobile only.
</div>
<div className="mobile-text-container1">
  This is additional information visible on mobile only.
</div>
  
</div>
      <TabContent key={activeTab} activeTab={activeTab} isMobile={isMobile} onPulse={setTriggerPulse} />
    </div>
    <Analytics />
    
  </div>
);

}

export default Homepage;